module.exports = __webpack_public_path__ + "static/media/add complain.3ec41fde.svg";